import { defineStore } from "pinia";
import { ref } from "vue";
import useMyFetch from "@stores/useMyFetch";
import { watchDebounced } from "@vueuse/core";
import { captureEvent } from "@/lib/analytics";

export const usePricerProjectsStore = defineStore("pricerProjects", () => {
  const projects = ref([]);
  const endClients = ref([]);
  const projectsSearchQuery = ref("");
  const projectsCount = ref(0);
  const currentPage = ref(1);
  const ownerFilter = ref([]);
  const customerFilter = ref([]);
  const endClientFilter = ref([]);
  const clients = ref([]);

  const fetch = async (options = { name: "", page: 1 }) => {
    const { response, data } = await useMyFetch(`/pricer/projects?name=${options.name}&page=${options.page}`)
      .json()
      .get();
    if (response.value.ok) {
      const { projects: pricerProjects, projects_count } = data.value;
      projects.value = pricerProjects;
      projectsCount.value = projects_count;
    }
    const { response: res, data: endClient } = await useMyFetch(`/pricer/projects/end_clients`).json().get();

    if (res.value.ok) {
      endClients.value = endClient.value;
    }

    const { response: resp, data: dataClient } = await useMyFetch(`/pricer/projects/clients`).json().get();

    if (resp.value.ok) {
      clients.value = dataClient.value;
    }
    return projects.value;
  };

  const search = async () => {
    const params = {
      name: projectsSearchQuery.value,
      page: currentPage.value,
      owner: ownerFilter.value,
      client: customerFilter.value,
      end_client: endClientFilter.value,
    };
    const { response, data } = await useMyFetch(`/pricer/projects/search`).json().post(params, null);

    if (response.value.ok) {
      const { projects: pricerProjects, projects_count } = data.value;
      projects.value = pricerProjects;
      projectsCount.value = projects_count;
    }

    return projects.value;
  };

  const changePage = async (page) => {
    currentPage.value = page;
    await search();
  };

  const deleteProject = async (token) => {
    const { response } = await useMyFetch(`/pricer/projects/${token}`).json().delete();

    if (response.value.ok) {
      projects.value = projects.value.filter((project) => project.token !== token);

      captureEvent("pricer_project_deleted", { project_token: token });
    }
    return projects.value;
  };

  const clearFilters = async () => {
    ownerFilter.value = [];
    customerFilter.value = [];
    endClientFilter.value = [];
    await search();
  };

  watchDebounced(projectsSearchQuery, () => search(), { debounce: 300 });

  return {
    // state
    projects,
    projectsSearchQuery,
    projectsCount,
    currentPage,
    ownerFilter,
    customerFilter,
    endClientFilter,
    endClients,
    clients,

    // actions
    fetch,
    search,
    changePage,
    deleteProject,
    clearFilters,
  };
});
